module.exports = {"TXTWCL_There_are_price_updates":{"id":"TXTWCL_There_are_price_updates","defaultMessage":"Il y a des mises à jour de prix"}}